module.exports = __webpack_public_path__ + "static/media/baojing.979a12a0.mp3";